import { render, staticRenderFns } from "./wxQuickLogin.vue?vue&type=template&id=18a34ca9&scoped=true"
import script from "./wxQuickLogin.vue?vue&type=script&lang=js"
export * from "./wxQuickLogin.vue?vue&type=script&lang=js"
import style0 from "./wxQuickLogin.vue?vue&type=style&index=0&id=18a34ca9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a34ca9",
  null
  
)

export default component.exports